import { defineComponent as a, h as r, computed as s } from "vue";
import "./composables/useShowPriceDisclaimer.js";
import { getSpacingClass as e } from "./composables/useSpacingClass.js";
const c = a({
  name: "VHeadline",
  props: {
    bottomSpacing: {
      type: String,
      default: "",
      validator: (t) => ["xs", "s", "m", "l", ""].includes(t)
    },
    topSpacing: {
      type: String,
      default: "",
      validator: (t) => ["xs", "s", "m", "l", "xl", ""].includes(t)
    },
    center: {
      type: Boolean,
      default: !1
    },
    /** Use when need to label an element for a11y */
    id: {
      type: String,
      required: !1,
      default: ""
    },
    /** If not provided will use a slot */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    level: {
      type: Number,
      validator(t) {
        return [1, 2, 3, 4, 5, 6].indexOf(t) !== -1;
      },
      default: 2
    },
    size: {
      type: String,
      validator(t) {
        return ["l", "m", "s", "xs", "xxs"].indexOf(t) !== -1;
      },
      default: "s"
    },
    color: {
      type: String,
      validator(t) {
        return ["dark", "white"].indexOf(t) !== -1;
      },
      default: "dark"
    },
    as: {
      type: String,
      validator(t) {
        return ["h", "span"].indexOf(t) !== -1;
      },
      default: "h"
    }
  },
  render() {
    let t;
    return this.$slots && this.$slots.default && (t = this.$slots.default()), r(
      "div",
      {
        class: `hobi-headline tw-block tw-not-italic tw-font-obi-bold ${this.cssClass.toString().replace(/,/gi, " ")}`
      },
      // props/attributes
      this.title || t
    );
  },
  setup(t) {
    const l = (i) => {
      switch (i) {
        case "xxs":
          return "tw-text-lg";
        case "xs":
          return "tw-text-3xl";
        case "s":
          return "tw-text-4xl";
        case "m":
          return "tw-text-5xl";
        case "l":
          return "tw-text-6xl";
      }
    };
    return {
      cssClass: s(() => [
        l(t.size),
        t.color === "dark" ? "tw-text-gray-900" : "tw-text-white",
        `hobi-headline--level-${t.level}`,
        t.center ? "tw-text-center" : "",
        e(t.bottomSpacing, "b"),
        e(t.topSpacing, "t")
      ])
    };
  }
});
export {
  c as _
};
